export default __webpack_public_path__ + "static/media/bfit_logo.6c9f3b1d.svg";